import type { ConfiguratorState, Recommendation } from './types';

export const initialConfiguratorState: ConfiguratorState = {
  business: '',
  objective: '',
  impact: '',
  features: [],
  timeline: '',
  budget: '',
};

export function buildRecommendation(input: ConfiguratorState): Recommendation {
  const immersiveSignals = input.impact === 'Inmersivo' || input.features.includes('3D / WebGL');
  const commerceSignals = input.features.some((feature) => ['Cotizador', 'Reservas', 'Catálogo'].includes(feature));
  const launchSignal = input.objective === 'Lanzar algo nuevo';
  const highBudget = ['ARS 9M — 15M', 'Más de ARS 15M'].includes(input.budget);

  if ((immersiveSignals && highBudget) || (launchSignal && highBudget)) {
    return {
      package: launchSignal ? 'Lanzamiento digital integral' : 'Experiencia inmersiva de marca',
      code: launchSignal ? 'ÓRBITA / L-04' : 'CAMPO / I-03',
      summary: launchSignal
        ? 'Una puesta en escena completa para convertir atención en demanda: concepto, narrativa, experiencia interactiva y sistema comercial.'
        : 'Una experiencia donde la forma de explorar es parte del argumento de marca, con WebGL progresivo y recorridos guiados.',
      price: input.budget || 'ARS 9M — 15M',
      timeline: input.timeline || '10 a 16 semanas',
      sections: ['Apertura cinematográfica', 'Manifiesto de marca', 'Exploración interactiva', 'Prueba / producto', 'Conversión guiada', 'Contacto'],
      features: ['Dirección de arte', 'Sistema 3D adaptativo', ...input.features, 'Motion avanzado', 'Medición de conversión'].slice(0, 7),
      score: 94,
    };
  }

  if (commerceSignals || input.objective === 'Generar consultas calificadas' || input.objective === 'Vender o reservar online') {
    return {
      package: input.features.includes('Catálogo') ? 'Catálogo interactivo comercial' : 'Sitio de conversión animada',
      code: 'PULSO / C-02',
      summary: 'Un recorrido comercial claro y expresivo, construido para calificar interés, resolver objeciones y llevar cada visita al próximo paso.',
      price: input.budget || 'ARS 5M — 9M',
      timeline: input.timeline || '6 a 10 semanas',
      sections: ['Propuesta central', 'Problema / oportunidad', 'Servicios o productos', 'Flujo guiado', 'Prueba social', 'Preguntas clave', 'Consulta'],
      features: ['Narrativa de conversión', ...input.features, 'WhatsApp contextual', 'Panel de contenidos', 'Analítica preparada'].slice(0, 7),
      score: 89,
    };
  }

  return {
    package: input.impact === 'Cinemático' ? 'Sitio institucional premium' : 'Presencia editorial de marca',
    code: 'SEÑAL / P-01',
    summary: 'Una presencia distintiva, rápida y precisa para que la marca deje de verse intercambiable y empiece a comunicar valor desde el primer scroll.',
    price: input.budget || 'ARS 2M — 5M',
    timeline: input.timeline || '4 a 6 semanas',
    sections: ['Apertura de marca', 'Posicionamiento', 'Servicios', 'Diferenciales', 'Casos o enfoque', 'Contacto'],
    features: ['Dirección visual', 'Motion editorial', ...input.features, 'SEO técnico', 'Captura de consultas'].slice(0, 7),
    score: 82,
  };
}

export function recommendationWhatsApp(recommendation: Recommendation, input: ConfiguratorState) {
  const text = [
    'Hola NODO CERO, armé un pasaporte de proyecto en el configurador.',
    `Recomendación: ${recommendation.package} (${recommendation.code}).`,
    `Negocio: ${input.business}.`,
    `Objetivo: ${input.objective}.`,
    `Presupuesto: ${input.budget}.`,
    'Quiero conversar sobre el alcance.',
  ].join(' ');
  return `https://wa.me/5491155550190?text=${encodeURIComponent(text)}`;
}
